export type UserPermissionKey = "reassign_tasks" | "escalate_tasks";

export type UserPermissions = Record<UserPermissionKey, boolean>;

export const defaultUserPermissions = (): UserPermissions => ({
  reassign_tasks: false,
  escalate_tasks: false,
});

export function normalizeUserPermissions(
  permissions?: Partial<UserPermissions> | null
): UserPermissions {
  return {
    ...defaultUserPermissions(),
    ...permissions,
  };
}
